module.exports = __webpack_public_path__ + "img/photo-car-service-transportation-concept-tow-truck-transpo-1.f6a7cce5.webp";